import type { ToastMessageOptions } from "primevue/toast";
import { HTTP_STATUS_TITLES } from "@/config";

let handler: ((opts: ToastMessageOptions) => void) | null = null;

/** Registers the toast handler (called from App.vue). */
export const setErrorToastHandler = (fn: (opts: ToastMessageOptions) => void) => {
  handler = fn;
};

const titleForStatus = (status: number): string => {
  if (HTTP_STATUS_TITLES[status]) return HTTP_STATUS_TITLES[status];
  if (status >= 500) return "Server Error";
  return `${status} Error`;
};

/** Shows an error toast for the given HTTP status. */
export const showErrorToast = (status: number, detail?: string) => {
  if (!handler) return;
  handler({
    severity: "error",
    summary: titleForStatus(status),
    detail: detail ?? "Request failed.",
    life: 10000,
  });
};
